import Loading from '../../../Common/Loading';
import { usePaymentsChartsContext } from './hooks/usePaymentsChartsContext';
import { PaymentsMonthAvg } from './PaymentsMonthAvg';
import { PaymentsMonthSum } from './PaymentsMonthSum';
import { PaymentsYearAvg } from './PaymentsYearAvg';
import { PaymentsYearSum } from './PaymentsYearSum';


export const Charts = () => {
    const { isLoading } = usePaymentsChartsContext();

    if (isLoading) {
        return (
            <Loading message="Devido ao alto volume de informações, essa operação pode levar alguns instantes." />
        );
    }

    return (
        <>
            <div className='chats-indicators-side-by-side-dashboards'>
                <PaymentsYearSum/>
                <PaymentsMonthSum/>
            </div>
            <div className='chats-indicators-side-by-side-dashboards'>
                <PaymentsYearAvg />
                <PaymentsMonthAvg />
            </div>
        </>
    );
};
